import { SVGProps } from 'react';

export const RefetchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='17'
    height='16'
    viewBox='0 0 17 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <mask
      id='mask0_54_1068'
      style={{ maskType: 'alpha' }}
      maskUnits='userSpaceOnUse'
      x='0'
      y='0'
      width='17'
      height='16'>
      <rect x='0.5' width='16' height='16' fill='#D9D9D9' />
    </mask>
    <g mask='url(#mask0_54_1068)'>
      <path d='M8.53341 13.3333C7.04453 13.3333 5.77786 12.8167 4.73341 11.7833C3.68897 10.75 3.16675 9.48888 3.16675 7.99999V7.88332L2.56675 8.48332C2.30901 8.74106 1.89115 8.74106 1.63341 8.48332C1.37568 8.22559 1.37568 7.80772 1.63341 7.54999L3.47986 5.70354C3.67512 5.50828 3.99171 5.50828 4.18697 5.70354L6.03342 7.54999C6.29115 7.80772 6.29115 8.22559 6.03341 8.48332C5.77568 8.74106 5.35781 8.74106 5.10008 8.48332L4.50008 7.88332V7.99999C4.50008 9.1111 4.89175 10.0555 5.67508 10.8333C6.45842 11.6111 7.41119 12 8.53341 12C8.8223 12 9.10564 11.9667 9.38342 11.9C9.50204 11.8715 9.61966 11.837 9.73626 11.7963C10.0205 11.6973 10.3436 11.7435 10.5565 11.9564C10.8814 12.2813 10.8092 12.8287 10.38 12.9926C10.2215 13.0531 10.0615 13.1056 9.90008 13.15C9.45564 13.2722 9.00008 13.3333 8.53341 13.3333ZM13.5203 10.2964C13.325 10.4917 13.0085 10.4917 12.8132 10.2964L10.9667 8.44999C10.709 8.19226 10.709 7.77439 10.9667 7.51666C11.2245 7.25892 11.6423 7.25892 11.9001 7.51666L12.5001 8.11666V7.99999C12.5001 6.88888 12.1084 5.94443 11.3251 5.16666C10.5417 4.38888 9.58897 3.99999 8.46675 3.99999C8.17786 3.99999 7.89453 4.03332 7.61675 4.09999C7.49812 4.12846 7.38051 4.16301 7.26391 4.20364C6.97967 4.30268 6.65652 4.25643 6.44369 4.0436C6.11881 3.71871 6.19095 3.17125 6.62017 3.00736C6.77868 2.94684 6.93865 2.89438 7.10008 2.84999C7.54453 2.72777 8.00008 2.66666 8.46675 2.66666C9.95564 2.66666 11.2223 3.18332 12.2667 4.21666C13.3112 5.24999 13.8334 6.5111 13.8334 7.99999V8.11666L14.4334 7.51666C14.6911 7.25892 15.109 7.25892 15.3667 7.51666C15.6245 7.77439 15.6245 8.19226 15.3667 8.44999L13.5203 10.2964Z' />
    </g>
  </svg>
);
